import React, { Component, useState, Fragment } from "react";
//import compose from 'recompose/compose';
import config from '../../config';
import { connect } from "react-redux";
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import DatePicker from "react-datepicker";
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { withStyles } from "@material-ui/core/styles";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Typography from "@material-ui/core/Typography";
import { shopActions } from "../../_actions";
import { apiConstants } from '../../_constants/api.constants';
import { uploadService } from "../../_services/upload.service";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import loader from '../../_assets/Ring-Loading.gif';

//-- CSS for Material
const styles = theme => ({
    root: {
        maxWidth: '75%',
        margin: '0 auto',
    },
    paddingBox: {
        padding: theme.spacing(2)
    },
    loaderImg: {
        margin: '0 auto',
        display: 'block',
        width: '100%'

    },
    newPasswordRequired: {
        padding: '2px 10px 2px 10px',
        borderRadius: '30px',
        color: 'white',
        backgroundColor: 'grey',
        cursor: 'pointer'
    }
});

class ViewShopkeeper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editShopKeeeperId: '',
            country: '',
            region: '',
            defaultData: {},
            validated: { errors: { coupon_title: "", description: "" } },
            file: null,
            src: null,
            crop: {
                unit: "%",
                width: 100,
                aspect: 1 / 1
            },
            croppedImageUrl: null,
            nowCropImage: false,
            notifyPopup: false,
            dataSavedSuccess: false,
            shopkeeperData: [],
            imageChangesOrNot: 0
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;
        const { match } = this.props;
        const shopkkeperId = match.params.id
        //const editShopkeeprid = '5e884271a64dae0e943803d3';
        this.setState({ editShopKeeeperId: shopkkeperId });
        const obj = {};
        obj.shopkeeprId = shopkkeperId;
        dispatch(shopActions.getShopKeeper(apiConstants.GET_SHOPKEEPER, obj));
    }



    // this life cycle method trigger when new data arrive on component
    componentWillReceiveProps(props) {
        if (props.getShopkeeper !== undefined) {
            if (props.getShopkeeper.data.shopkeeper) {
                const shopeeprUser = props.getShopkeeper.data.shopkeeper[0];
                this.setState({
                    shopkeeperData: props.getShopkeeper.data.shopkeeper[0],
                    firstname: shopeeprUser.firstname,
                    lastname: shopeeprUser.lastname,
                    selectedDate: new Date(shopeeprUser.dob),
                    // password: shopeeprUser.password,
                    email: shopeeprUser.email,
                    contact_number: shopeeprUser.mobile_number,
                    street: shopeeprUser.locations[0].street,
                    city: shopeeprUser.locations[0].city,
                    country: shopeeprUser.locations[0].country,
                    region: shopeeprUser.locations[0].state,
                    zipcode: shopeeprUser.locations[0].zipCode,

                    shop_title: shopeeprUser.shopData[0].title,
                    shop_licence: shopeeprUser.shopData[0].licenceNo,
                    shop_contact: shopeeprUser.shopData[0].contactNo,
                    shop_logo: shopeeprUser.shopData[0].shopLogo,
                    shop_street: shopeeprUser.shopData[0].address.street,
                    shop_city: shopeeprUser.shopData[0].address.city,
                    shop_country: shopeeprUser.shopData[0].address.country,
                    shop_region: shopeeprUser.shopData[0].address.state,
                    shop_zipcode: shopeeprUser.shopData[0].address.zipCode,
                })
            }
        }
        // send page to shopkeepr list if data is updates
        if (props.updateShopAndShopkeeperList !== undefined &&
            props.updateShopAndShopkeeperList.updateShopAndShopkeeper !== undefined &&
            props.updateShopAndShopkeeperList.updateShopAndShopkeeper.data !== undefined &&
            props.updateShopAndShopkeeperList.updateShopAndShopkeeper.data.success === true) {
            this.setState({ dataSavedSuccess: true });
            setTimeout(function () { props.history.push('/shopkeeper'); }, 3000);
        }
    }


    render() {
        const { classes } = this.props;
        const { siteConstants } = this.props.language;
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return (

            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/shopkeeper">{siteConstants.MENU_SHOPKEEPER}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    Data
                                </li>

                                <li style={{ paddingLeft: "730px" }}>
                                    <a href="/shopkeeper" className="darkLink"><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}
                                    </a>
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <Card className={classes.root}>
                                <form role="form" className="col-md-12 col-xs-12" autoComplete="off" encType="multipart/form-data">
                                    <CardContent>

                                        <div className="row">
                                            <div className="col-md-12 fontColorHeading">
                                                <b>{siteConstants.LABEL_USER_SECTION_HEAD}</b>
                                            </div>
                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label><b>{siteConstants.LABEL_FIRST_NAME}</b></label>
                                                    <p>{this.state.firstname}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label><b>{siteConstants.LABEL_LAST_NAME}</b></label>
                                                    <p>{this.state.lastname}</p>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label><b>{siteConstants.LABEL_DOB}</b></label><br />
                                                    {this.state.selectedDate !== undefined ? this.state.selectedDate.toLocaleString("en-US", options) : ''}


                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label><b>{siteConstants.LABEL_EMAIL}</b></label>
                                                    <p>{this.state.email} </p>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label><b>{siteConstants.LABEL_CONTACT_NO}</b></label>
                                                    <p>{this.state.contact_number} </p>

                                                </div>
                                            </div>
                                            <div className="col-md-12 fontColorHeading">
                                                <b>{siteConstants.LABEL_LOCATION_SECTION}</b>
                                            </div>
                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <p>{this.state.street} {this.state.city} {this.state.region} {this.state.country} {this.state.zipcode}</p>
                                                </div>
                                            </div>


                                            <div className="col-md-12 fontColorHeading">
                                                <b>{siteConstants.LABEL_SHOP_SECTION_HEAD}</b>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label><b>{siteConstants.LABEL_SHOP_TITLE}</b></label>
                                                    <p>{this.state.shop_title}</p>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label><b>{siteConstants.LABEL_SHOP_LICENCE}</b></label>
                                                    <p>{this.state.shop_licence}</p>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label><b>{siteConstants.LABEL_SHOP_CONTACT}</b></label>
                                                    <p>{this.state.shop_contact}</p>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <img src={`${config.imgPath}` + '/uploads/shop-logo/' + this.state.shop_logo} style={{ width: "200px" }} />
                                                </div>
                                            </div>


                                            <div className="col-md-12 col-xs-12">
                                                <div className="form-group">
                                                    <label><b>{siteConstants.LABEL_SHOP_FULL_INFO}</b></label>
                                                    <p>{this.state.shop_street} {this.state.shop_city} {this.state.shop_region} {this.state.shop_country} {this.state.shop_zipcode} </p>
                                                </div>
                                            </div>


                                        </div>

                                    </CardContent>
                                </form>

                            </Card>

                            <br />
                        </div>
                        {/* <!-- /.container-fluid --> */}
                    </div>
                    {/* <!-- End of Main Content --> */}
                    <Footer />






                </div>
            </div>
        );
    }
}
//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, getShopkeeper, updateShopAndShopkeeperList } = state;
    return {
        language,
        getShopkeeper,
        updateShopAndShopkeeperList
    };
}

//export default compose( withStyles(styles),connect(mapStateToProps))(ViewShopkeeper)

const connectedViewShopkeeper = connect(mapStateToProps)(withStyles(styles)(ViewShopkeeper));
export { connectedViewShopkeeper as ViewShopkeeper };
